import { t } from '@/features/i18n/utils';
import { OfferBreadcrumbs } from '@/features/subcontractor-bids/components/offer-breadcrumbs';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Icon } from '@/ui/components/icon';
import { FolderIcon } from '@hugeicons-pro/core-stroke-rounded';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderBackButton, HeaderChatButton } from '@/ui/components/header';
import { MainHeader, MainHeaderBackButton, MainScrollArea } from '@/ui/components/main';
import { H1 } from '@/ui/components/heading';
import {
  FilesPageAddFilesButton,
  FilesPageCount,
} from '@/features/documents/components/files-page/files-page-header';
import { offerDetailsQuery } from '@/features/subcontractor-bids/queries';
import { entityDocumentsQuery } from '@/features/documents/queries';
import { FilesPageList } from '@/features/documents/components/files-page/files-page-list';
import { FileUploadDialog } from '@/features/documents/components/file-upload';
import { IndexingStatusAlerts } from '@/features/documents/components/indexing-status-alerts';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/',
)({
  component: RouteComponent,
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.query({
        ...offerDetailsQuery(params.subcontractorId),
        staleTime: 'static',
      }),
      context.queryClient.query({
        ...entityDocumentsQuery(params.subcontractorId, 'subcontractor'),
        staleTime: 'static',
      }),
    ]),
});

function RouteComponent() {
  const { projectId, workspaceId, procurementId, subcontractorId } = Route.useParams();
  const navigate = useNavigate();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <OfferBreadcrumbs subcontractorId={subcontractorId}>
          <BreadcrumbPage>
            <Icon icon={FolderIcon} />
            {t({ en: 'Files', nb: 'Filer' })}
          </BreadcrumbPage>
        </OfferBreadcrumbs>
        <HeaderChatButton />
      </Header>
      <MainScrollArea>
        <IndexingStatusAlerts resourceId={subcontractorId} documentType="subcontractor" waitForKg />
        <MainHeader>
          <H1>
            <MainHeaderBackButton
              to="/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId"
              params={{ projectId, workspaceId, procurementId }}
            />
            {t({ en: 'Files', nb: 'Filer' })}
            <FilesPageCount resourceId={subcontractorId} resourceType="subcontractor" />
          </H1>
          <FilesPageAddFilesButton resourceId={subcontractorId} resourceType="subcontractor" />
        </MainHeader>
        <FilesPageList
          resourceId={subcontractorId}
          resourceType="subcontractor"
          onRowClick={(doc) => {
            navigate({
              to: '/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/offers/$subcontractorId/files/$documentId',
              params: {
                projectId,
                workspaceId,
                procurementId,
                subcontractorId,
                documentId: doc.id,
              },
            });
          }}
        />
        <FileUploadDialog resourceId={subcontractorId} resourceType="subcontractor" />
      </MainScrollArea>
    </>
  );
}
